const config = {
  api: {
    // url: 'http://api.mediasourceinn.com/v1',
    url: 'http://localhost:3012/v1',
  },
  cms: {
    url: 'http://localhost:7777',
  },
  s3: {
    url: 'http://localhost:3011',
  },
  demo_url: 'https://my-json-server.typicode.com/typicode/demo',
};

export default config;
